// API Configuration for different environments
const config = {
  development: {
    apiBaseUrl: 'http://localhost:8080/admin/api',
    uploadsBaseUrl: 'http://localhost:8080/admin/uploads',
    frontendUrl: 'http://localhost:3000',
    adminUrl: 'http://localhost:3001/admin'
  },
  production: {
    apiBaseUrl: 'https://drgurjar.com/admin/api',
    uploadsBaseUrl: 'https://drgurjar.com/admin/uploads',
    frontendUrl: 'https://drgurjar.com',
    adminUrl: 'https://drgurjar.com/admin'
  }
};

// Determine current environment
const getEnvironment = () => {
  // Check if we're in browser environment
  if (typeof window !== 'undefined') {
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1' || 
           window.location.hostname.includes('localhost') 
           ? 'development' : 'production';
  }
  // Node.js environment
  return process.env.NODE_ENV || 'development';
};

const environment = getEnvironment();

// Export the configuration for the current environment
export default {
  ...config[environment],
  environment,
  isDevelopment: environment === 'development',
  isProduction: environment === 'production'
};